export type CsvValue = boolean | number | string | null | undefined;

const escapeCsvValue = (value: CsvValue): string => {
  const stringValue = value == null ? '' : String(value);
  const spreadsheetSafeValue = /^[=+\-@]/.test(stringValue)
    ? `'${stringValue}`
    : stringValue;

  return `"${spreadsheetSafeValue.replace(/"/g, '""')}"`;
};

export const serializeCsv = (
  headers: string[],
  rows: CsvValue[][]
): string => {
  return [headers, ...rows]
    .map(row => row.map(escapeCsvValue).join(','))
    .join('\n');
};

export const downloadFile = (
  filename: string,
  contents: BlobPart,
  type: string
): void => {
  const blob = new Blob([contents], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
